import {
  GET_CURRENT_USER_DATA,
  GET_CURRENT_USER_DATA_ERROR,
  UPDATE_CURRENT_USER_DATA,
  UPDATE_CURRENT_USER_DATA_ERROR,
  MANUALLY_TRIGGER_STATUS,
  UPDATE_CURRENT_DATA_PASSWORD,
  UPDATE_CURRENT_DATA_PASSWORD_ERROR,
  MANUALLY_TRIGGER_ROLE
} from "../types";

import * as api from "../../api/axiosBase";

import {
  updateCurrentUserDataProps,
  updateCurrentUserPasswordProps
} from "../../types/actions/currentUser";

// get current user data action
export const getCurrentUserData = () => async (dispatch) => {
  try {
    const { data } = await api.getCurrentUserData();
    dispatch({
      type: GET_CURRENT_USER_DATA,
      payload: data.data.data
    });
  } catch (error) {
    //dispatch({ type: LOGIN, payload: error.response.data.status });
    // dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
  }
};

// update current user data action
export const updateCurrentUserData =
  (formData: updateCurrentUserDataProps) => async (dispatch) => {
    try {
      const { data } = await api.updateCurrentUserData(formData);
      dispatch({ type: UPDATE_CURRENT_USER_DATA, payload: data });
      dispatch(getCurrentUserData());
    } catch (error) {
      dispatch({
        type: UPDATE_CURRENT_USER_DATA_ERROR,
        payload: error.response.data
      });
    }
  };

// manually trigger success status
export const manuallyTrigerSuccess = () => async (dispatch) => {
  try {
    dispatch({
      type: MANUALLY_TRIGGER_STATUS
    });
  } catch (error) {
    //dispatch({ type: LOGIN, payload: error.response.data.status });
    // dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
  }
};

// update current user password
export const updateCurrentUserPassword =
  (formData: updateCurrentUserPasswordProps) => async (dispatch) => {
    try {
      const { data } = await api.updateCurrentUserPassword(formData);
      dispatch({ type: UPDATE_CURRENT_DATA_PASSWORD, payload: data });
    } catch (error) {
      dispatch({
        type: UPDATE_CURRENT_USER_DATA_ERROR,
        payload: error.response.data
      });
    }
  };

// manually trigger role
export const manuallyTrigerRole = (message: any) => (dispatch) => {
  dispatch({ type: MANUALLY_TRIGGER_ROLE, payload: message });
};
